import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import { ConfigurationApiDatasourceInfo } from "../../ExternalApi/ConfigurationApi"

import ShomiPng from '../../Assets/Shomi.png';

const DatasourceHaloPSA = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mHasAllSettings, SetHasAllSettings] = useState(false); 

    const [mTicketTypes, SetTicketTypes] = useState(null); 
    const [mTicketTypesError, SetTicketTypesError] = useState(""); 
    //const [mTicketTypes, SetTicketTypes] = useState([{ID: 1, Name: "type1"},{ID: 2, Name: "type2"},{ID: 3, Name: "type3"}]); 

    const UpdateDatasourceSetting = (aValue, aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue

        SetReady()
    }

    const GetTicketTypes = async () => {
        try 
        {
            SetTicketTypesError("")
            SetTicketTypes(null)

            const result = await ConfigurationApiDatasourceInfo(props.SecurityToken, props.IntegrationSettings.DatasourceType, "TicketTypes", props.IntegrationSettings.DatasourceSettings)
            console.log("GetInfo tickettypes returned", result)
            if (result.status === 200)
            {                
                SetTicketTypes(result.data.Info) //Select all by default
            }    
            else
            {
                SetTicketTypesError("Failed to retrieve ticket types. Check your settings")
            }    
        } 
        catch (ex) 
        {    
            console.log("GetInfo tickettypes error", ex)
            SetTicketTypesError(ex.response.data)
            return
        }
    }

    const SetReady = () => 
    {
        const Ready = (props.IntegrationSettings.DatasourceSettings.Domain)
            && (props.IntegrationSettings.DatasourceSettings.ClientID)
            && (props.IntegrationSettings.DatasourceSettings.ClientSecret)
        props.OnSetReady(Ready)
        SetHasAllSettings(Ready)
    }

    const BrandingId = sessionStorage.getItem("BrandingId")
    const BrandingSubId = sessionStorage.getItem("BrandingSubId")

    return (
        <div className="scriptitembody">
            
            <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.Domain || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Domain")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Client ID").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="password" value={props.IntegrationSettings.DatasourceSettings.ClientID || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ClientID")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Client secret").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="password" value={props.IntegrationSettings.DatasourceSettings.ClientSecret || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ClientSecret")} className="wizardinputfield"/></div>

            {((BrandingId === "enreach") && (BrandingSubId === "enreach")) ?   
                <span>    
                    <br/><br/>              
                    <div height="20" style={{ borderTop: "2px #6001B5 solid", borderBottom: "2px #6001B5 solid", backgroundColor: "#E6D7EF", padding: "5px"}}>
                        <img src={ShomiPng} height="20" style={{ marginTop: -2 }}/> Shomi
                    </div> 
                    <div className="wizardfieldname">{Translate("Ticket type").toUpperCase()}</div>
                    <div className="wizardfieldvalue">
                        {mTicketTypes != null ?
                            <select name="Region" value={props.IntegrationSettings.DatasourceSettings.TicketCategoryID} onChange={evt => UpdateDatasourceSetting(evt.target.value, "TicketTypeID")} className="wizardinputfield">
                                {mTicketTypes.map((tickettype, index) => <option key={"tickettype" + index} value={tickettype.ID}>{tickettype.Name}</option>)}
                            </select>                            
                            : <>
                                <Button disabled={!mHasAllSettings} variant="dark" className={"brandbuttonprimary"} onClick={() => GetTicketTypes()}>{Translate("Retrieve ticket types").toUpperCase()}</Button>  
                                {mTicketTypesError}
                            </>                           
                        }
                    </div>
                </span>
                : <></>
            }

                        
        </div>
    );
}

DatasourceHaloPSA.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceHaloPSA